import { createSlice, PayloadAction } from "@reduxjs/toolkit";

//App
import { SearchDefaultValue, SearchValue } from "./types";
import { LookupValueStoreState } from "../types/lookupValue";

const initialState: LookupValueStoreState = {
  searchValue: SearchDefaultValue,
  isActive: true,
};

export const lookupvalue = createSlice({
  name: "lookupvalue",
  initialState,
  reducers: {
    setSearchValue: (state, action: PayloadAction<SearchValue>) => {
      state.searchValue.name = action.payload.name;
    },
    setIsActive: (state) => {
      state.isActive = !state.isActive;
    },
  },
});

export const { setSearchValue, setIsActive } = lookupvalue.actions;

export const selectSearchValue = (state: { lookupvalue: LookupValueStoreState }) =>
  state?.lookupvalue?.searchValue;
export const selectIsActive = (state: { lookupvalue: LookupValueStoreState }) =>
  state?.lookupvalue?.isActive;

export default lookupvalue.reducer;
